import React from "react";
import { markdown } from "markdown";

export default ({ buttonText, icon, link, onClick }) => (
  <div className="row">
    <div className="col-md-12">
      <p>
        <a
          className="btn btn-primary btn-lg btn-load-more"
          href={link || null}
          onClick={onClick || null}
        >
          {buttonText} <i className={`icon-${icon}`} />
        </a>
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/button.js